<template>
  <div class="container">
    <div class="content">
      <h3 class="title is-3">What is your real plan?</h3>
      <p class="is-medium">
        It's relatively easy to budget and save when your financial situation is stable.  However, life and money have a tendency to change and not all situations are stable.  
      </p>
      <p>The Real Plan Calculator is built to answer questions about what happens when your financial situation changes in the future.  Specifically, it illustrates how additional savings and income impact your future net worth.  It can answer questions like:</p>
      <ul>
        <li>How long can I live on my savings before I run out of money?</li>
        <li>What happens if I lose or leave my job?</li>
        <li>Do I have enough money saved to move out?</li>
        <li>Do I have enough income to live without roommates?</li>
        <li>What will it look like if my side business starts making money in the future?</li>
        <li>What would happen if my partner left their job?</li>
        <li>What will our net worth look like if we buy a house or car or (gasp) boat?</li>
      </ul>
      <h4 class="title is-4">How it works:</h4>
      <p>
        The tool is split into sections with visuals to illustrate your
        future. At a basic level, we're looking at your monthly income and
        expenses to calculate your monthly net. The monthly net increases or
        decreases your available savings.</p>
        <p>You can also input a future
        monthly income or expense item. The idea is to see if or how long your
        savings will last if your new income doesn't begin for a while.
      </p>
      <p>
        As an example, you might want to try the following:
        <ol>
          <li>Input your current financial situation</li>
          <li>Inclue any projected future
        income or expenses</li>
        <li>Remove your salary to see what happens if it goes away</li>
        </ol>
      </p>
      <p>
        A slightly more optimistic exercise might follow the steps above, but add some type of future income.  For example, maybe you have a side business (or part time job) that earns $0 today, but you think could earn $2k per month after 5 months of effort.  You can input that amount as a future income to see the impact.
      </p>
      <p>
        Don't worry, none of the data you input gets stored anywhere. It only
        lives in your web browser.
      </p>
      
      <!-- <h4 class="title is-4">This is how to use the different sections:</h4> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "What",
  data() {
    return {};
  },
};
</script>

<style>
</style>